"use strict";
import Vue from "vue";
import Clipboard from "clipboard";

let clipboard;

Vue.directive("btnClipboard", {
  bind: function (el, binding, vNode, oldNode) {
    const { value = "bottom" } = binding;
    clipboard = new Clipboard(el);
    let $el = window.$(el);
    $el.tooltip({
      title: "Copiado",
      placement: value,
      trigger: "manual",
      html: true,
      container: "body",
    });
    el.addEventListener("click", () => {
      $el.tooltip("show");
      setTimeout(() => {
        $el.tooltip("hide");
      }, 2000);
    });
  },
  update: function (el) {},
  unbind: function (el) {
    clipboard.listener.destroy();
  },
});
